module.exports = __webpack_public_path__ + "accountant.f02add92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/profile/accountant.png
// module id = 2240
// module chunks = 0